module.exports = __webpack_public_path__ + "static/media/Bluelab-Peripod-Peristaltic-Pump-M4_PERIPODM4_1.e7f5a444.webp";